import { lazy } from 'react';

export const LazyEditorPage = lazy(
  () =>
    import(
      /* webpackChunkName: "hellospa--page--editor-page" */ './editor-page'
    ),
);
